import TransactionDetailsWrapper from "components/__new/common/TransactionDetailsWrapper";
import CurrencyFormat from "utils/currencyFormat";
import DateFormat, { TimeFormat } from "utils/dateFormat"
import { useMemo } from "react";

const TransferDetailsModal = ({transaction, setIsOpen, isOpen, isCredit, banks}) => {
    const transactionAmount = `-${CurrencyFormat(transaction?.amount / 100)}`
    
    const bankName = useMemo(() => {
        if (banks?.length === 0 || !transaction?.senderBankCode) return "";
        
        const bankDetails = banks.find((bank) => +(bank?.bankCode || bank?.institutionCode) === +transaction?.senderBankCode);
        return (bankDetails?.bankName || bankDetails?.institutionName) || "";
    }, [banks, transaction]); 
    
    return (
        <TransactionDetailsWrapper
            title={transaction?.type}
            subtitle={
                `${transaction?.product?.charAt(0).toUpperCase()}${transaction?.product?.substring(1)}`
            }
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            isCredit={transaction?.type === "credit"}
            amount={transactionAmount}
            status={transaction?.status}
            padFooter="20px"
            documentTitle={`Transfer Receipt - ${DateFormat(transaction?.createdAt)}`}>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Reference</div>
                    <div className="text-ep-gray-700">
                        {transaction?.reference}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Time</div>
                    <div className="text-ep-gray-700">
                        {DateFormat(transaction?.createdAt)} at {TimeFormat(transaction?.createdAt)}
                    </div>
                </div>
                
                
                {
                    transaction?.type === "credit" ? (
                        <>
                            <div className="w-full flex items-center justify-between text-sm mt-7">
                                <div className="text-ep-gray-500">Account Name</div>
                                <div className="text-ep-gray-700 capitalize">
                                    {transaction?.senderAccountName ?? "-"}
                                </div>
                            </div>
                
                            <div className="w-full flex items-center justify-between text-sm mt-7">
                                <div className="text-ep-gray-500">Bank Name</div>
                                <div className="text-ep-gray-700 capitalize">
                                    {bankName || "-"}
                                </div>
                            </div>
                            
                            <div className="w-full flex items-center justify-between text-sm mt-7">
                                <div className="text-ep-gray-500">Account Number</div>
                                <div className="text-ep-gray-700 capitalize">
                                    {transaction?.senderAccountNumber ?? "-"}
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="w-full flex items-center justify-between text-sm mt-7">
                                <div className="text-ep-gray-500">Account Name</div>
                                <div className="text-ep-gray-700 capitalize">
                                    {transaction?.destinationAccountName ?? "-"}
                                </div>
                            </div>

                            <div className="w-full flex items-center justify-between text-sm mt-7">
                                <div className="text-ep-gray-500">Description</div>
                                <div className="text-ep-gray-700 capitalize">
                                    {transaction?.description ?? "-"}
                                </div>
                            </div>
                
                            <div className="w-full flex items-center justify-between text-sm mt-7">
                                <div className="text-ep-gray-500">Account Number</div>
                                <div className="text-ep-gray-700 capitalize">
                                    {transaction?.destinationAccountNumber ?? "-"}
                                </div>
                            </div>
                        </>
                    )
                }

                {
                    transaction?.sessionId && (
                        <>
                            <div className="w-full flex items-center justify-between text-sm mt-7">
                                <div className="text-ep-gray-500">Session ID</div>
                                <div className="text-ep-gray-700">
                                    {transaction?.sessionId || "N/A"}
                                </div>
                            </div>
                        </>
                    )
                }
        </TransactionDetailsWrapper>
    )
}


export default TransferDetailsModal
